import { cn } from './ui/utils';

export function CardIcon({ icon: Icon, className, iconClassName, ...props }) {
  return (
    <div
      className={cn(
        'flex h-10 w-10 shrink-0 items-center justify-center rounded-md',
        className
      )}
      aria-hidden="true"
      {...props}
    >
      <Icon className={cn('h-[18px] w-[18px] shrink-0', iconClassName)} />
    </div>
  );
}
